/* v60.js – header, meniu, căutare, coș. Fără jQuery, fără dependențe. */
(function () {
  'use strict';
  var R = window.V60 || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  /* în previzualizare (temă nepublicată) cererile interne trebuie să rămână pe aceeași temă */
  function U(u) { try { var t = window.Shopify && Shopify.theme; if (!t || t.role === 'main') return u; var x = new URL(u, location.origin); x.searchParams.set('preview_theme_id', t.id); return x.pathname + x.search; } catch (e) { return u; } }
  window.V60U = U;
  var money = function (c) { var v = (c / 100).toFixed(2).split('.'); return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1] + ' lei'; };


  /* imagini care nu se văd la încărcare: data-msd-lazy="view" → abia când apar pe ecran (ascunse = deloc) */
  (function () {
    function sw(i) { var s = i.getAttribute('data-msd-srcset'), u = i.getAttribute('data-msd-src'); if (s) { i.setAttribute('srcset', s); i.removeAttribute('data-msd-srcset'); } if (u) { i.setAttribute('src', u); i.removeAttribute('data-msd-src'); } i.removeAttribute('data-msd-lazy'); }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); sw(e.target); } }); }, { rootMargin: '200px 200px 300px 200px' }) : null;
    function watch(root) { $$('img[data-msd-lazy="view"]', root).forEach(function (i) { if (i.__w) return; i.__w = 1; if (io) io.observe(i); else sw(i); }); }
    watch(); window.V60Lazy = watch;
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { watch(); }, 120); }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ───── header compact la derulare (telefon) ───── */
  var hd = $('#hd'), lastY = 0, tick = false, mq = matchMedia('(max-width:1024px)');
  function onScroll() {
    tick = false; if (!hd || !mq.matches) return;
    var y = window.scrollY;
    /* fără tremurat: când header-ul se micșorează, păstrăm spațiul în pagină (margin-bottom) ca să nu sară conținutul, și pragul are histerezis */
    var isC = hd.classList.contains('is-compact');
    if (!isC && y > 160) { var fh = hd.offsetHeight; hd.classList.add('is-compact'); hd.style.marginBottom = Math.max(0, fh - hd.offsetHeight) + 'px'; }
    else if (isC && y < 40) { hd.classList.remove('is-compact'); hd.style.marginBottom = ''; }
    if (y > 400 && y > lastY + 6) hd.classList.add('is-hidden');
    else if (y < lastY - 6 || y < 400) hd.classList.remove('is-hidden');
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ───── desktop: la derulare header-ul devine un singur rând fix (piramida + logo + căutare + iconițe), ca la eMAG;
     piramida deschide meniul verde de categorii sub el ───── */
  var mqd = matchMedia('(min-width:1025px)'), dc = false, tickD = false;
  function dcOff() { if (!hd) return; hd.classList.remove('is-dc', 'is-menu'); document.body.style.paddingTop = ''; dc = false; }
  function onScrollD() {
    tickD = false; if (!hd) return;
    if (!mqd.matches) { if (dc) dcOff(); return; }
    var y = window.scrollY;
    if (!dc && y > 220) { document.body.style.paddingTop = hd.offsetHeight + 'px'; hd.classList.add('is-dc'); dc = true; }
    else if (dc && y < 60) dcOff();
  }
  window.addEventListener('scroll', function () { if (!tickD) { tickD = true; requestAnimationFrame(onScrollD); } }, { passive: true });
  if (mqd.addEventListener) mqd.addEventListener('change', onScrollD);
  document.addEventListener('click', function (e) {
    if (!dc || !hd) return;
    if (e.target.closest('.hd__burger')) { e.preventDefault(); e.stopPropagation(); hd.classList.toggle('is-menu'); return; }
    if (hd.classList.contains('is-menu') && !e.target.closest('.hd__bar')) hd.classList.remove('is-menu');
  }, true);

  /* ───── meniul (desktop + telefon), încărcat o dată ───── */
  var mmP = null, mmDoc = null;
  function loadMenu() {
    if (mmP) return mmP;
    mmP = fetch(U((R.search || '/search') + '?view=mm'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      mmDoc = new DOMParser().parseFromString(h, 'text/html'); return mmDoc;
    }).catch(function () { mmP = null; });
    return mmP;
  }
  var dd = $('[data-mm-dd]'), ddTimer = null, ddCur = null;
  function showDd(li) {
    if (!dd) return;
    loadMenu().then(function (d) {
      if (!d || ddCur !== li) return;
      var sec = d.querySelector('.mm1[data-mm-k="' + li.getAttribute('data-mm-k') + '"]');
      if (!sec || !sec.querySelector('.mm1__cols')) { dd.hidden = true; return; }
      dd.innerHTML = ''; dd.appendChild(sec.cloneNode(true)); dd.hidden = false;
      $$('.hd__mi.is-open').forEach(function (x) { x.classList.remove('is-open'); }); li.classList.add('is-open');
    });
  }
  function hideDd() { if (!dd) return; dd.hidden = true; ddCur = null; $$('.hd__mi.is-open').forEach(function (x) { x.classList.remove('is-open'); }); }
  var bar = $('.hd__bar');
  if (bar) {
    bar.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var li = e.target.closest('.hd__mi'); clearTimeout(ddTimer);
      if (li && li !== ddCur) { ddCur = li; ddTimer = setTimeout(function () { if (li.classList.contains('has-dd')) showDd(li); else hideDd(); }, 90); }
    });
    bar.addEventListener('pointerleave', function () { clearTimeout(ddTimer); ddTimer = setTimeout(hideDd, 160); ddCur = null; });
    bar.addEventListener('pointerenter', function () { loadMenu(); });
  }
  if (hd) hd.addEventListener('pointerover', function () { if (!mq.matches) loadMenu(); }, { once: true, passive: true });

  /* sertarul (telefon): nivel 1 → nivel 2 → nivel 3 */
  var drawer = $('#mm-drawer'), body = drawer && $('[data-mm-body]', drawer), stack = [];
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  function renderLevel(level) {
    var head = $('.mmd__head', drawer), html = '';
    if (level.kind === 'root') {
      head.innerHTML = '<span class="mmd__t">Meniu</span>' + head.innerHTML.slice(head.innerHTML.indexOf('<button'));
      var tr = mmDoc.querySelector('[data-mm-trend]'); if (tr) html += tr.outerHTML;
      html += '<ul class="mmd__list" role="list">';
      $$('.mm1', mmDoc).forEach(function (s, i) {
        var t = s.getAttribute('data-t'), u = s.getAttribute('data-u'), d = s.getAttribute('data-d'), has = s.querySelector('.mm2');
        var inner = '<span>' + esc(t) + (d ? '<small>' + esc(d) + '</small>' : '') + '</span>';
        html += '<li>' + (has ? '<button type="button" class="mmd__a" data-go="1:' + i + '">' + inner + CHEV + '</button>' : '<a class="mmd__a" href="' + esc(u) + '">' + inner + '</a>') + '</li>';
      });
      html += '</ul>';
    } else {
      head.innerHTML = '<button type="button" class="mmd__back" data-back><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2"/></svg>' + esc(level.title) + '</button>' + head.innerHTML.slice(head.innerHTML.indexOf('<button type="button" class="mmd__x"'));
      html += '<a class="mmd__all" href="' + esc(level.url) + '">Mergi la ' + esc(level.title.replace('🔥', '').trim()) + '</a>';
      html += '<div class="msd-sub is-loading" data-sub="' + esc(level.url) + '"></div><ul class="mmd__list" role="list">';
      level.items.forEach(function (it, i) {
        html += '<li>' + (it.items.length ? '<button type="button" class="mmd__a" data-go="' + (stack.length + 1) + ':' + i + '"><span>' + esc(it.title) + '</span>' + CHEV + '</button>' : '<a class="mmd__a" href="' + esc(it.url) + '"><span>' + esc(it.title) + '</span></a>') + '</li>';
      });
      html += '</ul>';
    }
    body.innerHTML = html; body.scrollTop = 0;
    var sub = $('[data-sub]', body); if (sub) loadSub(sub);
  }
  function loadSub(box) {
    var u = box.getAttribute('data-sub'); if (u.indexOf('/collections/') < 0) { box.remove(); return; }
    var url = new URL(u, location.origin); url.searchParams.set('view', 'mmbest'); url.searchParams.set('sort_by', 'best-selling');
    fetch(U(url.pathname + url.search), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      if (!box.isConnected) return; if (!h || h.indexOf('msd-trending--sub') < 0 || /<html/i.test(h)) { box.remove(); return; }
      box.outerHTML = h;
    }).catch(function () { box.remove(); });
  }
  function levelFrom(sec) {
    if (sec.classList.contains('mm1')) return { title: sec.getAttribute('data-t'), url: sec.getAttribute('data-u'), items: $$('.mm2', sec).map(function (m) { return { title: m.getAttribute('data-t'), url: m.getAttribute('data-u'), items: $$('.mm3 a', m).map(function (a) { return { title: a.textContent, url: a.getAttribute('href'), items: [] }; }) }; }) };
    return sec;
  }
  function openDrawer() {
    if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden';
    $('[data-mm-open]').setAttribute('aria-expanded', 'true');
    loadMenu().then(function (d) { if (!d) return; stack = [{ kind: 'root' }]; renderLevel(stack[0]); });
  }
  function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.documentElement.style.overflow = ''; var b = $('[data-mm-open]'); if (b) b.setAttribute('aria-expanded', 'false'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mm-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-mm-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (drawer && !drawer.hidden) {
      var go = t.closest('[data-go]');
      if (go) {
        var p = go.getAttribute('data-go').split(':'), idx = +p[1], lvl;
        if (stack.length === 1) lvl = levelFrom($$('.mm1', mmDoc)[idx]); else { var it = stack[stack.length - 1].items[idx]; lvl = { title: it.title, url: it.url, items: it.items }; }
        stack.push(lvl); renderLevel(lvl); return;
      }
      if (t.closest('[data-back]')) { stack.pop(); renderLevel(stack[stack.length - 1]); return; }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeCart(); hideDd(); } });


  /* breadcrumb cu drumul real: la clic într-un meniu reținem lanțul (msd-bc.js îl folosește pe colecție și produs) */
  function pth(u) { try { return new URL(u, location.href).pathname.replace(/\/+$/, ''); } catch (e) { return u; } }
  function clean(t) { return String(t || '').replace(/🔥/g, '').trim(); }
  function setChain(c) { try { var last = c[c.length - 1]; sessionStorage.setItem('msd_bc_p', JSON.stringify({ u: last.u, c: c, t: Date.now() })); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var href = a.getAttribute('href'); if (!href || href.indexOf('/collections/') < 0) return;
    var c = null;
    if (a.closest('.hd__dd')) {
      var s1 = a.closest('.mm1'), s2 = a.closest('.mm2');
      c = [{ t: clean(s1.getAttribute('data-t')), u: pth(s1.getAttribute('data-u')) }];
      if (s2 && !a.classList.contains('mm1__all')) { c.push({ t: clean(s2.getAttribute('data-t')), u: pth(s2.getAttribute('data-u')) }); if (!a.classList.contains('mm2__t')) c.push({ t: clean(a.textContent), u: pth(href) }); }
    } else if (a.closest('.hd__menu')) {
      c = [{ t: clean(a.textContent), u: pth(href) }];
    } else if (drawer && drawer.contains(a) && (a.classList.contains('mmd__a') || a.classList.contains('mmd__all'))) {
      c = stack.slice(1).map(function (l) { return { t: clean(l.title), u: pth(l.url) }; });
      if (a.classList.contains('mmd__a')) c.push({ t: clean(a.textContent), u: pth(href) });
    }
    if (c && c.length) setChain(c);
  }, true);

  /* ───── căutarea rapidă (ca în v50): fereastră cu sugestii, categorii și produse din Search & Discovery (sections/v60-ps) ───── */
  (function () {
    var dlg = $('#psm'); if (!dlg || !dlg.showModal) return;
    var inp = $('[data-psm-in]', dlg), res = $('[data-psm-res]', dlg), clr = $('[data-psm-clr]', dlg);
    var t = null, ctrl = null, last = null, cache = {}, logT = null, logged = '', term = '';
    var LOG = 'https://ops.military-shop.ro/picking/search-api.php';
    function sid() { try { var s = localStorage.getItem('ms_search_sid'); if (!s) { s = 'ms_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9); localStorage.setItem('ms_search_sid', s); } return s; } catch (e) { return 'ms_anon'; } }
    function log(q) {
      q = (q || '').trim().toLowerCase(); if (q.length < 2 || q === logged) return; logged = q; var s = sid();
      try { localStorage.setItem('ms_last_search', JSON.stringify({ term: q, ts: Date.now(), sid: s })); } catch (e) {}
      fetch(LOG, { method: 'POST', keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'action=log&term=' + encodeURIComponent(q) + '&has_results=' + ($$('.psr__p a', res).length ? 1 : 0) + '&session_id=' + encodeURIComponent(s) }).catch(function () {});
    }
    function toCart(q) {
      q = (q || '').trim().toLowerCase(); if (q.length < 2) return;
      fetch('/cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _search_sid: sid(), _search_term: q, _search_ts: String(Date.now()) } }) }).catch(function () {});
    }
    function rv() { try { return JSON.parse(localStorage.getItem('v60_rv') || '[]'); } catch (e) { return []; } }
    function urlFor(q) {
      if (q) return (R.suggest || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=v60-ps&resources[type]=product,collection,query,page,article&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      var ids = rv();
      if (ids.length) return (R.search || '/search') + '?type=product&q=' + encodeURIComponent(ids.map(function (i) { return 'id:' + i; }).join(' OR ')) + '&section_id=v60-ps';
      return (R.root || '/') + '?section_id=v60-ps';
    }
    function show(h) { var d = document.createElement('div'); d.innerHTML = h; var r = $('[data-psr]', d); res.innerHTML = r ? r.outerHTML : ''; }
    function run() {
      var q = inp.value.trim(); clr.hidden = !q;
      if (q.length === 1 || q === last) return; last = q; term = q;
      var u = urlFor(q.length > 1 ? q : '');
      clearTimeout(logT); if (q.length > 1) logT = setTimeout(function () { log(q); }, 1500);
      if (cache[u]) { show(cache[u]); return; }
      if (ctrl) try { ctrl.abort(); } catch (e) {}
      ctrl = window.AbortController ? new AbortController() : null; res.classList.add('is-busy');
      fetch(u.indexOf('/suggest') > -1 ? u : U(u), { signal: ctrl && ctrl.signal, credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
        cache[u] = h; if (inp.value.trim() === q || (q.length < 2 && inp.value.trim().length < 2)) show(h);
      }).catch(function () {}).finally(function () { res.classList.remove('is-busy'); });
    }
    function open(q) {
      if (!dlg.open) { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
      if (typeof q === 'string' && q) inp.value = q;
      inp.focus(); last = null; run();
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    window.V60Search = { open: open, close: close };
    $$('[data-ps]').forEach(function (f) {
      var hi = $('[data-ps-input]', f);
      if (hi) {
        hi.setAttribute('readonly', '');
        hi.addEventListener('focus', function () { hi.blur(); open(hi.value); });
        hi.addEventListener('pointerdown', function (e) { e.preventDefault(); open(hi.value); });
      }
      f.addEventListener('submit', function (e) { e.preventDefault(); open(hi && hi.value); });
    });
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-search-open]'); if (b) { e.preventDefault(); open(); } });
    document.addEventListener('keydown', function (e) { if (e.key === '/' && !dlg.open && !/INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); open(); } });
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 150); });
    clr.addEventListener('click', function () { inp.value = ''; inp.focus(); run(); });
    $('[data-psm-x]', dlg).addEventListener('click', close);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { close(); return; }
      if (e.target.closest('[data-psr-clear]')) { try { localStorage.removeItem('v60_rv'); } catch (_) {} cache = {}; last = null; run(); return; }
      if (e.target.closest('a[href]') && term) { clearTimeout(logT); log(term); toCart(term); }
    });
    $('form', dlg).addEventListener('submit', function (e) { var q = inp.value.trim(); if (!q) { e.preventDefault(); return; } clearTimeout(logT); log(q); toCart(q); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('[data-psr-i],[data-psr-all]', res); if (!items.length) return;
      var i = items.indexOf(document.activeElement); e.preventDefault();
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : i - 1;
      if (i < 0) inp.focus(); else items[i].focus();
    });
    /* rezultatele „fără termen” se pregătesc când mouse-ul ajunge pe câmp */
    $$('[data-ps]').forEach(function (f) { f.addEventListener('pointerenter', function () { var u = urlFor(''); if (!cache[u]) fetch(U(u), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) { cache[u] = h; }).catch(function () {}); }, { once: true }); });
  })();

  /* ───── coșul ───── */
  var cd = $('#cart-drawer'), cdIn = cd && $('[data-cart-in]', cd);
  function setCount(n) { $$('[data-cart-count]').forEach(function (b) { b.textContent = n; if (+n > 0) b.removeAttribute('data-zero'); else b.setAttribute('data-zero', ''); }); }
  setCount((($('[data-cart-count]') || {}).textContent || '0').trim());
  function renderCart() {
    return fetch(U((R.cart || '/cart') + '?view=drawer'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      if (cdIn) { cdIn.innerHTML = h; $$('script', cdIn).forEach(function (s) { if (!s.type || s.type === 'text/javascript') { var n = document.createElement('script'); n.textContent = s.textContent; s.replaceWith(n); } }); }
      try { var m = JSON.parse(($('[data-cart-meta]', cdIn) || {}).textContent || '{}'); if ('count' in m) setCount(m.count); } catch (e) {}
      if (window.msdEtaFill) window.msdEtaFill(cdIn);
    });
  }
  function openCart() { if (!cd) { location.href = R.cart || '/cart'; return; } cd.hidden = false; document.documentElement.style.overflow = 'hidden'; if (!cdIn.innerHTML) cdIn.innerHTML = '<div class="mmd__load"></div>'; return renderCart(); }
  function closeCart() { if (!cd || cd.hidden) return; cd.hidden = true; document.documentElement.style.overflow = ''; }
  window.V60Cart = {
    open: openCart, close: closeCart, refresh: renderCart, setCount: setCount,
    add: function (items) {
      return fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { document.dispatchEvent(new CustomEvent('cart:added', { detail: j })); return openCart(); });
    }
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]'); if (o && cd) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var q = e.target.closest('.cd [data-q]');
    if (q) {
      var it = q.closest('[data-key]'); cd.classList.add('is-busy');
      fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.getAttribute('data-key'), quantity: +q.getAttribute('data-q') }) })
        .then(renderCart).finally(function () { cd.classList.remove('is-busy'); });
    }
  });


  /* ───── colecții: produsele epuizate la sfârșitul întregii liste ─────
     La clic pe un link spre o colecție (fără parametri) deschidem lista cu filtrul „În stoc”; la capătul ei, „Arată și produsele epuizate” continuă lista. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('data-ff-link') || a.hasAttribute('data-more')) return;
    var u; try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || u.search || u.hash) return;
    if (!/^\/collections\/[^/]+\/?$/.test(u.pathname) || /^\/collections\/(all|vendors|types)\/?$/.test(u.pathname)) return;
    e.preventDefault(); location.href = u.pathname + '?filter.v.availability=1';
  });


  /* accesibilitate: orice iframe fără titlu (pixeli Shopify/aplicații, hărți) primește unul */
  (function () {
    function t(f) { if (!f.title) f.title = /pixel|sandbox/i.test(f.id + f.src) ? 'Statistici magazin (ascuns)' : /maps/i.test(f.src) ? 'Hartă' : 'Conținut încorporat'; }
    $$('iframe').forEach(t);
    if ('MutationObserver' in window) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (n.tagName === 'IFRAME') t(n); else if (n.querySelectorAll) $$('iframe', n).forEach(t); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* butonul „Adaugă în coș” de pe carduri (msd-card) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-msd-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); if (b.getAttribute('aria-busy') === 'true') return;
    var lbl = b.textContent; b.setAttribute('aria-busy', 'true');
    window.V60Cart.add([{ id: +b.getAttribute('data-msd-add'), quantity: 1 }]).then(function () { b.textContent = 'Adăugat ✓'; })
      .catch(function (err) { b.textContent = (err && err.description) || 'Stoc insuficient'; })
      .finally(function () { b.removeAttribute('aria-busy'); setTimeout(function () { b.textContent = lbl; }, 2200); });
  }, true);

  /* „Înapoi la rezultate”: pe colecții/căutare reținem lista și poziția */
  if (/^\/(collections\/[^/]+\/?$|search\/?$)/.test(location.pathname)) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]'); if (!a || !a.closest('main')) return;
      try { var p = new URL(a.href, location.href).pathname.replace(/^.*(\/products\/[^/?#]+).*$/, '$1'); sessionStorage.setItem('msd_back', JSON.stringify({ u: location.href, y: Math.round(scrollY), t: Date.now(), p: p })); } catch (_) {}
    }, true);
  }
})();
